<div class="single-file">
  <div fxLayout="row" fxLayoutAlign="space-between center">
    <div
      fxLayout="row"
      fxLayoutAlign="start center"
      fxLayoutGap="{{ FlexLayoutType.Gap.Small }}"
    >
      <div class="file-icon-wrapper">
        <mat-icon class="file-icon">insert_drive_file</mat-icon>
      </div>

      <!-- fxFlex by itself causes elem to fill the space available -->
      <div fxLayout="column" class="info">
        <h4 class="name">
          <a
            *ngIf="
              uploadStatus == DocumentUploadStatus.Uploaded;
              else withoutLink
            "
            href="#"
            (click)="onOpenFile($event)"
          >
            {{ name
            }}<mat-icon class="open-icon" aria-hidden="true"
              >open_in_new</mat-icon
            >
          </a>
          <ng-template #withoutLink>
            <span>
              {{ name
              }}<mat-icon class="open-icon" aria-hidden="true"
                >open_in_new</mat-icon
              >
            </span>
          </ng-template>
        </h4>
        <span class="size"
          >{{ formatBytes(size) }}
          <span>{{ pages ? '(' + pages + ' pages)' : '' }}</span></span
        >
        <goa-file-upload-progress-bar
          *ngIf="
            uploadStatus == DocumentUploadStatus.Uploading && progress < 100
          "
          [progress]="progress"
          style="max-width: 150px"
        ></goa-file-upload-progress-bar>
        <span
          class="uploading"
          *ngIf="uploadStatus == DocumentUploadStatus.Uploading"
          >Uploading...</span
        >
        <span
          class="date uploaded"
          *ngIf="uploadStatus == DocumentUploadStatus.Uploaded"
          >Uploaded - {{ uploadedOn | date: 'MMMM d, y, h:mm a' }}</span
        >
        <span
          class="uploading"
          *ngIf="uploadStatus == DocumentUploadStatus.Deleting"
          >Deleting...</span
        >
      </div>
    </div>
    <div fxLayout="row" fxLayoutGap="{{ FlexLayoutType.Gap.Small }}">
      <div style="align-self: center">
        <button
          *ngIf="
            uploadStatus == DocumentUploadStatus.Uploading;
            else deleteButton
          "
          mat-button
          color="primary"
          type="button"
          (click)="cancelUpload.emit()"
        >
          <mat-icon>delete</mat-icon>
          Cancel
        </button>
        <ng-template #deleteButton>
          <button
            mat-button
            type="button"
            color="primary"
            (click)="onDeleteFile()"
          >
            <mat-icon>delete</mat-icon>
            Remove
          </button>
        </ng-template>
      </div>
    </div>
  </div>
  <div class="error" *ngFor="let e of errors">{{ e.message }}</div>
</div>
